import React from 'react';

const ConfirmDeleteModal = ({ setShowConfirmModal, handleDeleteGroup }) => (
    <div style={styles.overlay}>
        <div style={styles.box}>
            <div style={styles.header}>
                <div style={styles.warningIcon}>
                    <i className="bi bi-exclamation-triangle" style={{ fontSize: '20px', color: '#dc2626' }}></i>
                </div>
                <div>
                    <h6 style={styles.title}>Delete Group</h6>
                    <p style={styles.subtitle}>This action cannot be undone</p>
                </div>
                <button style={styles.closeBtn} onClick={() => setShowConfirmModal(false)}>
                    <i className="bi bi-x-lg"></i>
                </button>
            </div>
            <div style={styles.body}>
                <p style={styles.message}>
                    Are you sure you want to delete this contact group? All contacts in this group will be permanently removed.
                </p>
            </div>
            <div style={styles.footer}>
                <button style={styles.btnSecondary} onClick={() => setShowConfirmModal(false)}>Cancel</button>
                <button style={styles.btnDanger} onClick={handleDeleteGroup}>
                    <i className="bi bi-trash" style={{ marginRight: 6 }}></i>
                    Yes, Delete
                </button>
            </div>
        </div>
    </div>
);

const styles = {
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 },
    box: { background: 'white', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', overflow: 'hidden' },
    header: { display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', borderBottom: '1px solid #f3f4f6', background: '#fff7f7' },
    warningIcon: { width: '40px', height: '40px', borderRadius: '10px', background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
    title: { margin: 0, fontSize: '15px', fontWeight: '700', color: '#111827' },
    subtitle: { margin: 0, fontSize: '12px', color: '#9ca3af' },
    closeBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: '14px', padding: 0, marginLeft: 'auto' },
    body: { padding: '20px' },
    message: { fontSize: '14px', color: '#6b7280', margin: 0, lineHeight: '1.6' },
    footer: { display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '14px 20px', borderTop: '1px solid #f3f4f6' },
    btnSecondary: { padding: '8px 16px', background: '#f3f4f6', color: '#374151', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
    btnDanger: { display: 'inline-flex', alignItems: 'center', padding: '8px 16px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
};

export default ConfirmDeleteModal;
